import { defineModule } from '@berky/module-contract'

/**
 * Das Manifest ist die einzige Verbindung zwischen Modul und Shell.
 * Die Shell findet diese Datei selbst — sie muss nirgends eingetragen werden.
 */
export default defineModule({
  id: 'service-hub',
  title: 'Service Hub',
  description: 'Montage-, Werkstatt-, Miet- und Dienstleistungsberichte erstellen und dokumentieren.',
  icon: 'Wrench',
  order: 50,
  apiBasePath: '/api/service-hub',

  // Kein scopes-Feld: die Anmeldung an der API macht die Plattform. Sie kennt
  // den Bereich der Umgebung, in der sie gerade läuft — useApiClient() hängt
  // das passende Token von selbst an.

  roles: ['service-hub.nutzer', 'service-hub.admin'],

  routes: () => import('./src/routes'),

  // Optional: eine Kennzahl für die Kachel auf der Startseite.
  // homeWidget: () => import('./src/home-widget'),
})
